import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';

import { CookieModule } from 'ngx-cookie';
import { UserService } from './shared/services/user.service';
import { FundraisingService } from './shared/services/fundraising.service';

import { SessionService } from './shared/services/session.service';
import { CommonDataService } from './shared/services/common-data.service';
import { ConfigService } from './config/config.service';
import { SystemService } from './shared/services/system.service';
import { ShopService } from './shared/services/shop.service';
import { PublicDataService } from './shared/services/public-data.service';
import { AccountService } from './shared/services/account.service';
import { MerchantdirService } from './shared/services/merchantdir.service';
import { httpExtensionService } from './shared/services/httpextension.service';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { ConfirmpasswordComponent } from './confirmpassword/confirmpassword.component';
import { HomeComponent } from './home/home.component';
import { ForgottenPasswordComponent } from './forgotten-password/forgotten-password.component';
import { routing } from './app.routing';
import { AuthorizationGuard } from './shared/guards/authorization.guard';
import { HeaderComponent } from './shared/header/header.component';
import { FooterComponent } from './shared/footer/footer.component';
import { SidebarComponent } from './shared/sidebar/sidebar.component';

import {
    SharedModule,
    ToggleButtonModule,
    ButtonModule,
    DropdownModule,
    CalendarModule,
    MessagesModule,
    PaginatorModule,
    GMapModule,
    OverlayPanelModule,
    TooltipModule,
    DialogModule,
} from 'primeng/primeng';

import { ConfirmPurchase } from './shared/services/confirmpurchase.service';
import { InfiniteScrollModule } from 'angular2-infinite-scroll';
import {SpinnerModule} from './shared/spinner/spinner.module';
import {SafeHtmlPipe} from './shared/SafeHtmlPipe';
import { CreateAccountComponent } from './create-account/create-account.component';
import { ThankyouComponent } from './thankyou/thankyou.component';
import { ConfirmpasswordSucessComponent } from './confirmpasswordsucess/confirmpasswordsucess.component';
import { SettingsService } from './shared/services/settings.service';



@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ConfirmpasswordComponent,
    CreateAccountComponent,
    HomeComponent,
    ForgottenPasswordComponent,
    HeaderComponent,
      FooterComponent,
    SidebarComponent,
    SafeHtmlPipe,
    ThankyouComponent,
    ConfirmpasswordSucessComponent
    
    
  ],
    imports: [
        BrowserModule,
        FormsModule,
        HttpModule,
        ReactiveFormsModule,
        routing,
        SharedModule,
        ToggleButtonModule,
        ButtonModule,
        DropdownModule,
        CalendarModule,
        MessagesModule,
        PaginatorModule,
        GMapModule,
        OverlayPanelModule,
        TooltipModule,
        CookieModule.forRoot(),
        InfiniteScrollModule,
        DialogModule,
        SpinnerModule  
        
        
        
    ],
  providers: [
      UserService,
      FundraisingService,
      ConfigService,
      SessionService,
      CommonDataService,
      SystemService,
      SettingsService,
      ShopService,
      PublicDataService,
      MerchantdirService,
      AuthorizationGuard,
      httpExtensionService,
      AccountService,
      ConfirmPurchase
  ],
  bootstrap: [AppComponent],
  exports: [
      SafeHtmlPipe
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts